import { render, staticRenderFns } from "./BillingTax.vue?vue&type=template&id=46f78e0c"
import script from "./BillingTax.vue?vue&type=script&lang=js"
export * from "./BillingTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports